import { render, staticRenderFns } from "./customer-create-list.vue?vue&type=template&id=2285b00a&scoped=true&"
import script from "./customer-create-list.vue?vue&type=script&lang=js&"
export * from "./customer-create-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-create-list.vue?vue&type=style&index=0&id=2285b00a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285b00a",
  null
  
)

export default component.exports